export default "__VITE_ASSET__Dxlj1Rtv__"